import { useContext } from 'react';
import { ProfileChartsDataContext } from '../contexts/ProfileChartsDataContext';

export const useProfileChartsDataContext = () => {
    return useContext(ProfileChartsDataContext);
};
